module.exports = "<div multiselect=\"\"\n    options=\"vm.schoolList\" \n    selected-model=\"vm.selectedItem\" \n    disabled=\"!row.isSelected || row.isDisabled || row.isReadOnly\"\n    translation-texts=\"vm.textConfig\"\n    events=\"vm.eventConfig\"\n    extra-settings=\"vm.config\">\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/tableGridDropdownCell/tableGridDropdownCell.html
// module id = 347
// module chunks = 1